import { RetailMarketing } from "../features/retail/pages/retail-marketing"
import { DashboardLayout } from "../layouts/DashboardLayout"

export default function RetailMarketingPage() {
  return (
    <DashboardLayout>
      <RetailMarketing />
    </DashboardLayout>
  )
}
